import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api/axios";

export default function SearchDropdown({ onClose }) {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!query.trim()) { setResults([]); return; }
    const timer = setTimeout(async () => {
      setLoading(true);
      try {
        const res = await api.get(`products/?search=${encodeURIComponent(query)}`);
        setResults(res.data?.results || res.data || []);
      } catch {
        setResults([]);
      } finally {
        setLoading(false);
      }
    }, 350);
    return () => clearTimeout(timer);
  }, [query]);

  const handleSelect = (product) => {
    navigate(`/products?search=${encodeURIComponent(query)}`);
    onClose();
  };

  return (
    <div
      className="absolute right-0 top-10 rounded-xl overflow-hidden"
      style={{
        width: "320px",
        background: "#fff",
        boxShadow: "0 8px 40px rgba(0,0,0,0.12)",
        border: "1px solid #f0ebe3",
        fontFamily: "Georgia, serif",
        zIndex: 100,
      }}
    >
      {/* Input */}
      <div className="flex items-center gap-3 px-4 py-3" style={{ borderBottom: "1px solid #f5f0e8" }}>
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#aaa" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
        <input
          autoFocus
          type="text"
          placeholder="Search candles, scents…"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          className="flex-1 text-sm outline-none bg-transparent"
          style={{ fontFamily: "Georgia, serif", color: "#2a2a2a", fontSize: "13px" }}
        />
        {query && (
          <button onClick={() => setQuery("")} style={{ color: "#aaa", background: "none", border: "none", cursor: "pointer", fontSize: "14px" }}>✕</button>
        )}
      </div>

      {/* Results */}
      <div style={{ maxHeight: "260px", overflowY: "auto" }}>
        {loading && (
          <div className="px-4 py-6 text-center text-xs" style={{ color: "#aaa", fontFamily: "Georgia, serif" }}>
            Searching…
          </div>
        )}
        {!loading && query && results.length === 0 && (
          <div className="px-4 py-6 text-center text-xs" style={{ color: "#aaa", fontFamily: "Georgia, serif" }}>
            No results found for "{query}"
          </div>
        )}
        {!loading && results.slice(0, 6).map((product) => (
          <button
            key={product.id}
            onClick={() => handleSelect(product)}
            className="w-full flex items-center gap-3 px-4 py-3 text-left transition-colors duration-150"
            style={{ background: "none", border: "none", cursor: "pointer", borderBottom: "1px solid #faf7f2" }}
            onMouseEnter={(e) => (e.currentTarget.style.background = "#fdf8f2")}
            onMouseLeave={(e) => (e.currentTarget.style.background = "none")}
          >
            <div
              className="flex-shrink-0 rounded-lg overflow-hidden"
              style={{ width: "38px", height: "38px", background: "#f5efe6" }}
            >
              {product.image && (
                <img src={product.image} alt={product.name} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
              )}
            </div>
            <div>
              <div className="text-xs font-semibold" style={{ color: "#2a2a2a", fontFamily: "Georgia, serif" }}>{product.name}</div>
              <div className="text-xs" style={{ color: "#e07b39", fontFamily: "Georgia, serif" }}>${product.price}</div>
            </div>
          </button>
        ))}
        {!loading && !query && (
          <div className="px-4 py-5 text-xs" style={{ color: "#bbb", fontFamily: "Georgia, serif" }}>
            Try "Floral", "Woody", "Vanilla"…
          </div>
        )}
      </div>

      {/* Footer CTA */}
      {results.length > 0 && (
        <button
          onClick={() => { navigate(`/products?search=${encodeURIComponent(query)}`); onClose(); }}
          className="w-full py-3 text-xs text-center transition-colors duration-150"
          style={{ background: "#fdf8f2", color: "#e07b39", fontFamily: "Georgia, serif", border: "none", borderTop: "1px solid #f0ebe3", cursor: "pointer", letterSpacing: "0.08em" }}
        >
          View all results →
        </button>
      )}
    </div>
  );
}